import { makeStyles } from '@mui/styles';

export const useCycleCountsStyle = makeStyles(() => ({
  overSelect: {
    variant: 'subtitle1',
    paddingTop: '10px',
    paddingLeft: '20px',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 4,
  },
  overSelectError: {
    display: 'flex',
    alignItems: 'center',
  },
}));
